<template>
  <!-- <div class="concert-banner"> -->
  <div v-background-image
       class="concert-banner"
       :data-src="'/img/banner/main-kv.jpg'"
       :data-default-src="'/img/banner/main-kv-small.png'"
  >
    <!-- <h2 class="title">
      {{ $t('CONCERT.BANNER_TITLE') }}
    </h2> -->
    <div class="banner-search">
      <a href="#" class="search-param"
         :class="{'disabled': !(countryList && (countryList[0] && countryList[0].length) && (countryList[1] && countryList[1].continent.length))}"
         @click.prevent.stop="(countryList && (countryList[0] && countryList[0].length) && (countryList[1] && countryList[1].continent.length)) ? modalActive.country=true : ''"
      >
        <i class="material-icons">
          location_on
        </i>
        <input v-model="inputLabel.country" :data-country="inputLabel.country" :placeholder="$t('CONCERT.FILTER_CITY')" type="text" aria-label="Filter city input">
        <span v-if="inputLabel.country===''" class="input-option">
          <i class="material-icons">
            arrow_drop_down
          </i>
        </span>
        <span v-else class="input-option clear"
              @click.prevent.stop="inputLabel.country = '', search.venue.city_id = '', getVenuesList()"
        >
          <i class="material-icons">
            cancel
          </i>
        </span>
      </a>
      <a href="#" class="search-param"
         :class="{'disabled': !(venuesList && venuesList.length)}"
         @click.prevent.stop="venuesList && venuesList.length ? modalActive.venue=true : ''"
      >
        <i class="material-icons">
          account_balance
        </i>
        <input v-model="inputLabel.venue" :data-venue="inputLabel.venue" :placeholder="$t('CONCERT.PERFORMANCE_VENUE')" type="text" aria-label="Filter venue input">
        <span v-if="inputLabel.venue===''" class="input-option">
          <i class="material-icons">
            arrow_drop_down
          </i>
        </span>
        <span v-else class="input-option clear"
              @click.prevent.stop="inputLabel.venue = '', search.venue.id = ''"
        >
          <i class="material-icons">
            cancel
          </i>
        </span>
      </a>
      <a href="#" class="search-param" @click.prevent.stop="modalActive.date=true">
        <i class="material-icons">
          event
        </i>
        <input v-model="inputLabel.date" :data-date="inputLabel.date" :placeholder="$t('CONCERT.PERFORMANCE_TIME')" type="text" aria-label="Filter time input">
        <span v-if="inputLabel.date===''" class="input-option">
          <i class="material-icons">
            arrow_drop_down
          </i>
        </span>
        <span v-else class="input-option clear"
              @click.prevent.stop="resetSearchBanner('date')"
        >
          <i class="material-icons">
            cancel
          </i>
        </span>
      </a>
      <!-- <a href="#" class="search-param keyword">
        <i class="material-icons">
          search
        </i>
        <input :placeholder="$t('CONCERT.FILTER_KEYWORD')" type="text" disabled>
      </a> -->
      <a href="#" class="btn-search" @click.prevent.stop="filterContent">
        {{ $t('COMMON.SEARCH') }}
      </a>
    </div>
    <ConcertCountryModal
      :open="modalActive.country"
      :locate-country="locateCountryLabel"
      :country-list="countryList"
      :global-search-layer="globalSearchLayer"
      :global-search-breadcrumbs="globalSearchBreadcrumbs"
      @update-val="updateInputVal"
      @update-country-search="updateCountrySearch"
      @close="updateCountry"
    />
    <ConcertLocationModal
      :open="modalActive.venue"
      :venue-list="venuesList"
      @update-val="updateInputVal"
      @close="updateVenue"
    />
    <DateRangePicker
      :default-start="this.$route.query.start"
      :default-end="this.$route.query.end"
      :display="modalActive.date"
      @apply="updateDate"
      @cancel="updateDate"
    />
  </div>
</template>

<script>
import DateRangePicker from '@/components/common/DateRangePicker.vue'
import ConcertCountryModal from '@/components/concert/ConcertCountryModal.vue'
import ConcertLocationModal from '@/components/concert/ConcertLocationModal.vue'
import EventService from '@/assets/services/EventService'

export default {
  name: 'ConcertSearchBanner',
  components: {
    DateRangePicker,
    ConcertCountryModal,
    ConcertLocationModal
  },
  directives: {
    'background-image': {
      // directive definition
      inserted(el, binding) {
        if (el.dataset.defaultSrc) {
          const img = new Image()
          img.src = el.dataset.defaultSrc
          img.onload = function () {
            el.style['background-image'] = 'url("' + img.src + '")'
            // el.className = 'concert-banner active'
            el.style.opacity = 1
          }
        }
        if (el.dataset.src) {
          const img = new Image()
          img.src = el.dataset.src
          img.onload = function () {
            el.style['background-image'] = 'url("' + img.src + '")'
            setTimeout(() => {
              el.className = 'concert-banner active'
              el.style.opacity = 1
            }, 100)
          }
          img.onerror = (err) => {
            console.error('Image load error', err)
            if (el.dataset.defaultSrc && el.src !== el.dataset.defaultSrc) {
              el.style['background-image'] = 'url("' + el.dataset.defaultSrc + '")'
              setTimeout(() => {
                el.style.opacity = 1
              }, 60)
            }
          }
        }
      }
    }
  },
  props: {},
  data() {
    return {
      imageLoaded: false,
      modalActive: {
        country: false,
        venue: false,
        date: false
      },
      countryList: [],
      countrySearch: {
        continent: '',
        country: '',
        state: '',
        municipalities: '',
        city: ''
      },
      venuesList: [],
      inputLabel: {
        country: '',
        venue: '',
        date: ''
      },
      search: {
        venue: {
          id: '',
          city_id: '',
          country_id: '',
          datetime: {
            start: '',
            end: ''
          }
        }
      },
      locateCountryLabel: '',
      globalSearchLayer: '',
      globalSearchBreadcrumbs: [{ name: this.$t('CONCERT.GLOBAL'), type: 'root' }],
      locateUserInfo: {
        continent: '',
        country: ''
      },
      hasRegroupCountryData: false
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    locale(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        this.resetSearchBanner()
        this.getContinents()
        // this.filterContent()
      }
    },
    venuesList(newVal) {
      if (newVal) {
        if (this.search.venue && this.search.venue.id) {
          let queryVenue = newVal.find(item => {
            return item.id === this.search.venue.id
          })
          this.inputLabel.venue = queryVenue && queryVenue.name
        }
      }
    },
    countryList(newVal) {
      if (newVal && newVal[0] && newVal[1] && newVal[1].cities) {
        if (this.search.venue && this.search.venue.city_id) {
          let queryCity = ''
          queryCity = newVal[0].find(item => {
            return item.id === this.search.venue.city_id
          })
          // Search from all city list
          if (!queryCity) {
            queryCity = newVal[1].cities.find(item => {
              return item.id === this.search.venue.city_id
            })
          }
          // Search from municipalities list
          if (!queryCity && newVal[1].municipalities) {
            queryCity = newVal[1].municipalities.find(item => {
              return item.id === this.search.venue.city_id
            })
          }
          this.inputLabel.country = queryCity && queryCity.langs[0].name
        }
      }
    }
  },
  created() {
  },
  async mounted() {
    await this.getContinents()
    await this.mappingRouterQuery()
  },
  methods: {
    async getContinents() {
      let res = await EventService.getContinents({ lang: this.$i18n.locale.toLowerCase(), page: 1 })
      if (res && res.data && res.data.data) {
        if (res.headers) {
          this.locateUserInfo = {
            continent: res.headers['concert-continent'],
            country: res.headers['concert-country']
          }
        }
        // init locale user country
        if (this.locateCountryLabel === '' && this.locateUserInfo.continent && this.locateUserInfo.country) {
          await this.resetGlobalSearchCountryData()
          const isLocaleUser = await this.locateUser(this.locateUserInfo.continent, this.locateUserInfo.country)
          if (isLocaleUser !== null) {
            await this.updateUserCities(this.locateUserInfo.continent, this.locateUserInfo.country)
            await this.getVenuesList()
          }
        }
        if (res && res.data) {
          this.$set(this.countryList, 1, {})
          this.$set(this.countryList[1], 'continent', res.data.data)
        }
        // update conuntry modale data
        // console.log('countrySearch: ', this.countrySearch)
        if (this.countrySearch) {
          if (this.countrySearch.continent) {
            await this.getCountries(this.countrySearch.continent)
          }
          if (this.countrySearch.continent && this.countrySearch.country) {
            // this.globalSearchBreadcrumbs = [{ name: this.$t('CONCERT.GLOBAL'), type: 'root' }]
            // await this.getStates(this.countrySearch.continent, this.countrySearch.country)
            // await this.getCities(this.countrySearch.continent, this.countrySearch.country, this.countrySearch.state)
            const continentId = this.countrySearch.continent
            const countryId = this.countrySearch.country
            const stateId = this.countrySearch.state
            const cityId = this.countrySearch.city
            // console.log('***** in', continentId, countryId, stateId, cityId)
            await this.revertGlobalSearch(continentId, countryId, stateId, cityId)
          }
          // console.log('countryList: ', this.countryList[1])
        }
      }
    },
    async getCountries(continentId) {
      let params = this.checkSearchParams({ lang: this.$i18n.locale.toLowerCase(), per_page: 20, page: 1 })
      const res = await EventService.getCountries(continentId, params)
      const continent = this.countryList[1].continent
      if (res && res.data) {
        this.$set(this.countryList, 1, {})
        this.$set(this.countryList[1], 'continent', continent)
        this.$set(this.countryList[1], 'countries', res.data)
      }
    },
    async getStates(continentId, conuntryId) {
      // console.log('getStates', continentId, conuntryId)
      let params = this.checkSearchParams({ lang: this.$i18n.locale.toLowerCase(), per_page: 50, page: 1 })
      let params2 = this.checkSearchParams({ q: { state_id: null }, lang: this.$i18n.locale.toLowerCase(), per_page: 50, page: 1 })
      const res = await EventService.getStates(continentId, conuntryId, params)
      // get municipalities
      const res2 = await EventService.getCountryCities(continentId, conuntryId, params2)
      const continent = this.countryList[1].continent
      const countries = this.countryList[1].countries
      if (res && res.data) {
        this.$set(this.countryList, 1, {})
        this.$set(this.countryList[1], 'continent', continent)
        this.$set(this.countryList[1], 'countries', countries)
        this.$set(this.countryList[1], 'states', res.data)
      }
      if (res2 && res2.data) {
        this.$set(this.countryList[1], 'municipalities', res2.data)
      }
    },
    async getCities(continentId, conuntryId, stateId) {
      // console.log('getCities', continentId, conuntryId, stateId)
      let res = ''
      let continent = this.countryList[1].continent
      let countries = this.countryList[1].countries
      let states = this.countryList[1].states
      let municipalities = this.countryList[1].municipalities
      let params = this.checkSearchParams({ lang: this.$i18n.locale.toLowerCase(), per_page: 50, page: 1 })
      // Check if country has state
      if (stateId) {
        res = await EventService.getStateCities(continentId, conuntryId, stateId, params)
      } else {
        res = await EventService.getCountryCities(continentId, conuntryId, params)
      }
      if (res && res.data) {
        this.$set(this.countryList, 1, {})
        this.$set(this.countryList[1], 'continent', continent)
        this.$set(this.countryList[1], 'countries', countries)
        this.$set(this.countryList[1], 'states', states)
        this.$set(this.countryList[1], 'municipalities', municipalities) //
        this.$set(this.countryList[1], 'cities', res.data)
      }
    },
    async getVenuesList() {
      let query = {}
      if (this.search.venue.city_id) {
        query.city_id = this.search.venue.city_id
        this.search.venue.country_id = ''
      } else if (this.search.venue.country_id) {
        query.country_id = this.search.venue.country_id
      }
      let params = this.checkSearchParams({ lang: this.$i18n.locale.toLowerCase(), per_page: 50, page: 1 })
      let res = await EventService.getVenues(query, params)
      if (res && res.data) {
        this.venuesList = res.data
      }
    },
    async getCityInfo(cityId) {
      // get country modal data/breadcrumbs by route query
      const res = await EventService.getCityInfo(cityId, { lang: this.$i18n.locale.toLowerCase(), per_page: 10, page: 1 })
      if (res) {
        const continentId = res.continent_id
        const countryId = res.country_id
        const stateId = res.state_id
        this.revertGlobalSearch(continentId, countryId, stateId, cityId)
      }
    },
    async revertGlobalSearch(continentId, countryId, stateId, cityId) {
      // console.log('revertGlobalSearch', continentId, countryId, stateId, cityId)
      // breadcrumbs init
      let breadcrumbs = [{ name: this.$t('CONCERT.GLOBAL'), type: 'root' }]
      let breadcrumbsLen = breadcrumbs.length
      if (continentId) {
        let selectedContinent = this.countryList[1].continent.find(continent => {
          return continent.id === continentId
        })
        this.countrySearch.continent = continentId
        breadcrumbs[breadcrumbsLen] = { name: selectedContinent.langs[0].name, type: 'continent' }
      }
      if (countryId) {
        await this.getCountries(continentId)
        this.globalSearchLayer = 'continent'
        let selectedCountry = this.countryList[1].countries.find(country => {
          return country.id === countryId
        })
        this.countrySearch.country = countryId
        breadcrumbsLen = breadcrumbs.length
        if (stateId) {
          breadcrumbs[breadcrumbsLen] = { name: selectedCountry.langs[0].name, type: 'country' }
        } else {
          breadcrumbs[breadcrumbsLen] = { name: selectedCountry.langs[0].name, type: 'state' }
        }
      }
      if (stateId) {
        await this.getStates(continentId, countryId)
        this.globalSearchLayer = 'country'
        let selectedStates = this.countryList[1].states.find(state => {
          return state.id === stateId
        })
        breadcrumbsLen = breadcrumbs.length
        breadcrumbs[breadcrumbsLen] = { name: selectedStates.langs[0].name, type: 'state' } //
      }
      this.globalSearchBreadcrumbs = breadcrumbs
      // Check if has state
      if (stateId && cityId) {
        this.countrySearch.state = stateId
        this.countrySearch.city = cityId
        await this.getCities(continentId, countryId, stateId)
        this.globalSearchLayer = 'state'
      } else if (cityId) {
        this.countrySearch.city = cityId
        await this.getCities(continentId, countryId)
        this.globalSearchLayer = 'state'
      }
    },
    async updateCountry(val) {
      this.modalActive.country = false
    },
    async updateVenue(val) {
      this.modalActive.venue = false
    },
    async updateDate(val) {
      if (val) {
        this.inputLabel.date = val.start + ' ~ ' + val.end
        this.search.venue.datetime.start = val.start !== 'YYYY/M/D' ? val.start : ''
        this.search.venue.datetime.end = val.end !== 'YYYY/M/D' ? val.end : ''
        // auto filter
        this.filterContent()
      }
      this.modalActive.date = false
      // update conuntry and venue modal
      if (val && this.locateUserInfo.continent && this.locateUserInfo.country) {
        await this.getContinents()
        await this.updateUserCities(this.locateUserInfo.continent, this.locateUserInfo.country)
        await this.getVenuesList()
        // this.inputLabel.country = ''
        // this.inputLabel.venue = ''
        // this.search.venue.id = ''
        // this.search.venue.city_id = ''
      }
    },
    async updateInputVal(type, label, val) {
      if (val && type === 'country') {
        this.inputLabel.country = label
        this.search.venue.city_id = val
        await this.getVenuesList()
        this.resetSearchBanner('venue')
        // auto filter
        this.filterContent()
      } else if (val && type === 'venue') {
        this.inputLabel.venue = label
        this.search.venue.id = val
        // auto filter
        this.filterContent()
      }
    },
    async updateCountrySearch(type, val, hasStates, isMunicipality) {
      // console.log('updateCountrySearch: ', type, val, hasStates, isMunicipality)
      this.countrySearch[type] = val
      if (val && type === 'continent') {
        this.getCountries(val)
      } else if (val && type === 'country') {
        if (hasStates) {
          this.getStates(this.countrySearch.continent, val)
        } else {
          this.getCities(this.countrySearch.continent, val)
        }
      } else if (val && type === 'state') {
        this.getCities(this.countrySearch.continent, this.countrySearch.country, val)
      } else if (val) {
        if (this.countrySearch.continent && this.countrySearch.country) {
          this.getCities(this.countrySearch.continent, this.countrySearch.country, this.countrySearch.state)
        } else {
          this.getCities(this.locateUserInfo.continent, this.locateUserInfo.country)
        }
      }
    },
    async filterContent() {
      // Filter content by query params
      let query = this.filterEmptyObject(this.search)
      this.changeRouterQuery(query)
      // Convert date to ISOString
      if (query && query.venue && query.venue.datetime && query.venue.datetime.start) {
        if (query.venue.datetime.start === query.venue.datetime.end) {
          // Convert data to M/D 00:00:00 ~ M/D 23:59:59
          const dat = new Date(query.venue.datetime.start)
          query.venue.datetime.end = dat.setSeconds(dat.getSeconds() + 86399)
        }
        query.venue.datetime.start = this.convertToISOString(query.venue.datetime.start)
      }
      if (query && query.venue && query.venue.datetime && query.venue.datetime.end) {
        query.venue.datetime.end = this.convertToISOString(query.venue.datetime.end)
      }
      this.$emit('update-params', query)
    },
    async resetSearchBanner(type) {
      switch (type) {
        case 'country':
          this.inputLabel.country = ''
          this.search.venue.city_id = ''
          break
        case 'venue':
          this.inputLabel.venue = ''
          this.search.venue.id = ''
          break
        case 'date':
          this.inputLabel.date = ''
          this.search.venue.datetime.start = ''
          this.search.venue.datetime.end = ''
          this.$route.query.start = ''
          this.$route.query.end = ''
          await this.getContinents()
          await this.updateUserCities(this.locateUserInfo.continent, this.locateUserInfo.country)
          await this.getVenuesList()
          break
        default:
          this.locateCountryLabel = ''
          this.inputLabel = {
            country: '',
            venue: '',
            date: ''
          }
          this.search = {
            venue: {
              id: '',
              city_id: '',
              country_id: '',
              datetime: {
                start: '',
                end: ''
              }
            }
          }
          this.countrySearch = {
            continent: '',
            country: '',
            state: '',
            city: ''
          }
          this.globalSearchBreadcrumbs = [{ name: this.$t('CONCERT.GLOBAL'), type: 'root' }]
          break
      }
    },
    async resetGlobalSearchCountryData() {
      this.countryList[1] = {
        continent: [],
        countries: [],
        state: [],
        municipalities: [],
        city: []
      }
    },
    async locateUser(continent, country) {
      let res = await EventService.getCountries(continent, { lang: this.$i18n.locale.toLowerCase(), per_page: 50, page: 1 })
      let locateCountry = ''
      if (res && res.data) {
        locateCountry = res.data.find(item => {
          return item.id === country
        })
      }
      if (locateCountry) {
        this.locateCountryLabel = locateCountry.langs[0].name
        return this.locateCountryLabel
      }
      return null
    },
    async updateUserCities(continent, country) {
      let params = this.checkSearchParams({ lang: this.$i18n.locale.toLowerCase(), per_page: 50, page: 1 })
      let res = await EventService.getCountryCities(continent, country, params)
      if (res && res.data) {
        this.countryList[0] = res.data
        this.search.venue.country_id = country
        return res.data
      }
      return null
    },
    filterEmptyObject(value) {
      if (typeof value === 'number' && value > 0) {
        return value
      } else if (typeof value === 'string' && value.length > 0) {
        return value
      } else if (typeof value === 'object' && Array.isArray(value) && value.length > 0) {
        let tempArray = value.map(item => {
          return this.filterEmptyObject(item)
        }).filter(item => {
          return item
        })
        return tempArray.length > 0 ? tempArray : null
      } else if (typeof value === 'object') {
        let tempObj = {}
        Object.keys(value).forEach(index => {
          let subItem = this.filterEmptyObject(value[index])
          if (subItem) tempObj[index] = subItem
        })
        return (Object.keys(tempObj).length > 0) ? tempObj : null
      }
      return null
    },
    async mappingRouterQuery(query, update) {
      if (this.$route.query && Object.keys(this.$route.query).length) {
        if (this.$route.query.city_id) {
          this.search.venue.city_id = this.$route.query.city_id
          this.search.venue.country_id = '' // delete locate country_id
          await this.getCityInfo(this.$route.query.city_id)
        }
        if (this.$route.query.venue_id) {
          this.search.venue.id = this.$route.query.venue_id
        }
        if (this.$route.query.start) {
          this.search.venue.datetime.start = this.$route.query.start
        }
        if (this.$route.query.end) {
          this.search.venue.datetime.end = this.$route.query.end
        }
        if (this.$route.query.start && this.$route.query.end) {
          this.inputLabel.date = this.$route.query.start + ' ~ ' + this.$route.query.end
        }
      }
      await this.getVenuesList()
      await this.filterContent()
    },
    changeRouterQuery(query = undefined) {
      let queryParam = {}
      if (query) {
        if (query.venue && query.venue.city_id) {
          queryParam.city_id = query.venue.city_id
        }
        if (query.venue && query.venue.id) {
          queryParam.venue_id = query.venue.id
        }
        if (query.venue && query.venue.datetime && query.venue.datetime.start) {
          queryParam.start = query.venue.datetime.start
        }
        if (query.venue && query.venue.datetime && query.venue.datetime.end) {
          queryParam.end = query.venue.datetime.end
        }
      }
      this.$router.replace({ query: Object.assign({}, queryParam) })
    },
    checkSearchParams(orinParams) {
      let params = orinParams
      if (this.search.venue.datetime.start) {
        params.start = this.search.venue.datetime.start
      }
      if (this.search.venue.datetime.end) {
        params.end = this.search.venue.datetime.end
      }
      return params
    },
    convertToISOString(date) {
      return new Date(date).toISOString()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.concert-banner{
  position: relative;
  height: 246px;
  background-color: $grey-f3;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  text-align: center;
  margin-top: 16px;
  padding: 0 100px;
  transition: all .4s ease-in;
  opacity: 0;
  &:after{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: .38;
  }
  &:before{
    content: '';
    position: relative;
    display: inline-block;
    width: 0;
    height: 100%;
    vertical-align: middle;
    background:#f00;
  }
  .title{
    position: relative;
    font-size: 36px;
    font-weight: 500;
    line-height: 1.6;
    color: $grey-50;
    padding: 64px 0 24px;
    margin: 0;
  }
  .banner-search{
    position: relative;
    display: inline-block;
    width: 100%;
    height: 56px;
    max-width: 1240px;
    margin: 0 auto;
    // border-radius: 100px;
    // background: #fff;
    overflow: hidden;
    vertical-align: middle;
    // transition: opacity .4s ease-in;
    // opacity: 0;
    z-index: 1;
    .search-param{
      display: inline-block;
      position: relative;
      width: calc((100% - 168px) / 3);
      float: left;
      text-decoration: none;
      height: 56px;
      border: 1px solid $grey-ec;
      border-right: 0;
      i{
        position: absolute;
        width: 24px;
        height: 24px;
        top: 0;
        bottom: 0;
        left: 24px;
        margin: auto;
        font-size: 24px;
        color: $theme-red;
      }
      input{
        width: 100%;
        height: 100%;
        outline: none;
        border: 0;
        padding: 0 40px 0 56px;
        font-size: 16px;
        color: $grey-9b;
        line-height: 1.6;
        cursor: pointer;
        // caret-color: transparent;
        pointer-events: none;
      }
      .input-option{
        position: absolute;
        right: 62px;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 1;
        i{
          color: #9b9b9b;
          width: 24px;
          height: 24px;
        }
        &.clear{
          i{
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
      &.disabled{
        cursor: not-allowed;
        input{
          background: $grey-f3;
        }
        i{
          color: $grey-9b;
        }
      }
      &:first-child{
        border-radius: 100px 0 0 100px;
        input{
          border-radius: 100px 0 0 100px;
        }
      }
      &.keyword{
        input{
          cursor: auto;
          pointer-events: initial;
        }
      }
    }
    .btn-search{
      display: inline-block;
      position: absolute;
      right: 0;
      text-decoration: none;
      width: 168px;
      height: 56px;
      font-size: 24px;
      font-weight: 500;
      line-height: 56px;
      text-align: center;
      color: #fff;
      background: $theme-red;
      border-radius: 0 100px 100px 0;
    }
  }
  // &.active{
  //   .banner-search{
  //     opacity: 1;
  //   }
  // }
}

@media only screen and (max-width: 1023.98px) {
  .concert-banner{
    padding: 0 36px;
    height: 380px;
    .title{
      font-size: 24px;
      padding: 48px 0 24px;
    }
    .banner-search{
      background: none;
      border-radius: 0;
      height: auto;
      padding-top: 50px;
      .search-param{
        width: 100%;
        margin-bottom: 8px;
        // border: 1px solid $grey-ec;
        border-radius: 0;
        border: 0;
        input{
          border-radius: 4px;
          overflow: hidden;
        }
        &:first-child{
          border-radius: 0;
          input{
            border-radius: 4px;
          }
        }
      }
      .btn-search{
        position: relative;
        width: 100%;
        margin: 8px 0 0;
        border-radius: 100px;
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .concert-banner{
    padding: 0 24px;
    height: 360px;
    .banner-search{
      padding-top: 24px;
    }
    .title{
      font-size: 20px;
      padding: 24px 0;
    }
  }
}

</style>
